import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFloat = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "antigravity",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_4",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 24,
				height: 24
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_0_4)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "antigravity_2",
				d: "M12.025 2C13.375 2 14.4292 2.50833 15.1875 3.525C15.9458 4.54167 16.5917 5.7 17.125 7C17.5583 8.05 17.975 9.21667 18.375 10.5C18.775 11.7833 19.2 13.075 19.65 14.375C20.0833 15.625 20.5583 16.8 21.075 17.9C21.5917 19 22.1917 19.9417 22.875 20.725C23.0083 20.875 23.0667 21.05 23.05 21.25C23.0333 21.45 22.9583 21.625 22.825 21.775C22.6917 21.925 22.5333 22.0083 22.35 22.025C22.1667 22.0417 21.9833 21.9833 21.8 21.85C20.4833 20.8167 19.4 19.6625 18.55 18.3875C17.7 17.1125 16.8417 16 15.975 15.05C15.4083 14.4167 14.8042 13.9167 14.1625 13.55C13.5208 13.1833 12.8083 13 12.025 13C11.2417 13 10.5292 13.1833 9.8875 13.55C9.24583 13.9167 8.64167 14.4167 8.075 15.05C7.20833 16 6.35 17.1125 5.5 18.3875C4.65 19.6625 3.56667 20.8167 2.25 21.85C2.06667 21.9833 1.88333 22.0417 1.7 22.025C1.51667 22.0083 1.35833 21.925 1.225 21.775C1.09167 21.625 1.01667 21.45 1 21.25C0.983333 21.05 1.04167 20.875 1.175 20.725C1.85833 19.9417 2.45833 19 2.975 17.9C3.49167 16.8 3.96667 15.625 4.4 14.375C4.85 13.075 5.275 11.7833 5.675 10.5C6.075 9.21667 6.49167 8.05 6.925 7C7.45833 5.7 8.10417 4.54167 8.8625 3.525C9.62083 2.50833 10.675 2 12.025 2ZM10.25 4.975C9.81667 5.625 9.43333 6.3 9.1 7C8.66667 7.93333 8.27917 8.9375 7.9375 10.0125C7.59583 11.0875 7.21667 12.25 6.8 13.5C7.13333 13.15 7.45417 12.8417 7.7625 12.575C8.07083 12.3083 8.39167 12.0667 8.725 11.85C9.25833 11.5333 9.7875 11.3125 10.3125 11.1875C10.8375 11.0625 11.4083 11 12.025 11C12.6417 11 13.2125 11.0625 13.7375 11.1875C14.2625 11.3125 14.7917 11.5333 15.325 11.85C15.6583 12.0667 15.9792 12.3083 16.2875 12.575C16.5958 12.8417 16.9167 13.15 17.25 13.5C16.8333 12.25 16.4542 11.0875 16.1125 10.0125C15.7708 8.9375 15.3833 7.93333 14.95 7C14.6167 6.3 14.2333 5.625 13.8 4.975C13.3667 4.325 12.775 4 12.025 4C11.275 4 10.6833 4.325 10.25 4.975Z",
				fill: "currentColor"
			})
		})]
	})
});
export default SvgFloat;
